import {requestPubnubApiGET, withCredentials} from "./apiClient";
import {parametersFromCookiesAndQuery} from "./utils";
export const tryLoggingUser = async () => {
  try {
    const sessionResponse = await withCredentials(requestPubnubApiGET)('/me');
    const userId = sessionResponse.body.result.user.id;
    identifyUser(userId, sessionResponse.body.result.user);
    return { userId };
  } catch (err) {
    return false;
  }
};

export const identifyUser = (id, user) => {
  if (window && window.analytics && window.analytics.identify) {
    window.analytics.identify(
      id,
      {
        email: user.email,
        first_name: user.properties.first === 'PubNub' ? '' : user.properties.first,
        last_name: user.properties.last === 'User' ? '' : user.properties.last,
        phone: user.properties.phone,
        website: user.properties.website,
        ...parametersFromCookiesAndQuery(),
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/session.js